import React, {useEffect} from 'react';
import './LogoutPage.scss';
import useAmplifyAuth from "../../../helpers/useAmplifyAuth";
import Loader from "../../common/Loader/Loader";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import { client } from '../../../App';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const LogoutPage = (props) => {
  let query = useQuery();
  const redirectUrl = query.get("redirectUrl") || "";

  const userFetched = useSelector(state => state.auth.userFetched);
  const user = useSelector(state => state.auth.user);

  const {
    handleSignout,
  } = useAmplifyAuth();
  const clearSession = async () => {
    await client().clearStore();
  }

  useEffect(() => {
    clearSession();
    if (userFetched) {
      if (user) {
        handleSignout(redirectUrl)
          .then(() => console.log('user logged out correctly'));
      }

    }
  }, [userFetched, user, handleSignout, redirectUrl]);

  return (
    <div className="HubPage" data-testid="HubPage">
      <div className="container">
        <div className="row">
          <div className="col">
            <div style={{height: 1000}}>
              <Loader/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};
LogoutPage.propTypes = {};

export default LogoutPage;
